// extracted by mini-css-extract-plugin
export default {"container":"_6QkIbQsl84qqVNmB5aF2t0","inertChildren":"_2hk3eYaCqhvQOpCPAug1Hu","siteShutdownNotice":"_3MBfdLxeLNbJNTc7uruB0m"};